module.exports = __webpack_public_path__ + "img/finance.cb19a768.png";